import type { AmDirectoryEntry } from '../../types/accountAnalytics';

// A native AM picker used by both staging entry points. Emits the chosen AM uid,
// `null` for "Unassign", or `undefined` while the placeholder is selected (so the
// caller can disable "Apply" until a real choice is made). Native <select> keeps
// it trivially testable (fireEvent.change) and portal-free.
const UNASSIGN = '__unassign__';
const PLACEHOLDER = '';

export function AmPicker({
  amDirectory,
  value,
  onChange,
  ariaLabel = 'Target account manager',
}: {
  amDirectory: AmDirectoryEntry[];
  // undefined = nothing picked yet; null = Unassign; string = a uid.
  value: string | null | undefined;
  onChange: (value: string | null | undefined) => void;
  ariaLabel?: string;
}) {
  const selectValue = value === undefined ? PLACEHOLDER : value === null ? UNASSIGN : value;
  return (
    <select
      aria-label={ariaLabel}
      value={selectValue}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v === PLACEHOLDER ? undefined : v === UNASSIGN ? null : v);
      }}
      className="rounded-md border border-slate-300 bg-white px-2 py-1.5 text-sm text-slate-700 focus:border-kyck-400 focus:outline-none"
    >
      <option value={PLACEHOLDER}>Select AM…</option>
      <option value={UNASSIGN}>Unassigned</option>
      {amDirectory.map((a) => (
        <option key={a.uid} value={a.uid}>
          {a.displayName ?? a.uid}
        </option>
      ))}
    </select>
  );
}
